<div class="tt-c-review-form-header-container">
  <div v-if="eriCampaignMessage" class="tt-c-review-form-eri-campaign" v-html="eriCampaignMessage" :class="{'tt-c-review-form-eri-campaign--inactive': !isEriCampaignActive}"></div>
  <div class="tt-c-review-form-header" :class="{'tt-c-review-form-header--with-image': hasImage}">
    <div class="tt-c-review-form-header__content--left">
      <div class="tt-c-review-form-header__heading" role="heading" :aria-level="globalConfig.modalHeadingLevel" v-html="heading"></div>
      <div v-if="catItem" class="tt-c-review-form-header__product-title" v-html="catItem.title"></div>
      <p v-if="description" class="tt-c-review-form-header__text" v-html="description"></p>
      <tt-button v-if="hasGuidelines"
                 type="link"
                 class="tt-c-review-form-header__guidelines-link"
                 @click.prevent="toggleGuidelines"
                 aria-controls="tt-c-review-form-guidelines"
                 :aria-expanded="showGuidelines.toString()"
                 v-html="glLinkText"></tt-button>
      <div v-if="hasGuidelines && showGuidelines" class="tt-c-review-form-guidelines">
        <p v-for="text in glTexts" class="tt-c-review-form-guidelines__text" v-html="text"></p>
        <ul class="tt-c-review-form-guidelines__list">
          <li v-for="i in 4" class="tt-c-review-form-guidelines__list-item" v-html="$msg(glPrefix + 'guidlines.rules' + i)"></li>
        </ul>
        <p class="tt-c-review-form-guidelines__text" v-html="$msg(glPrefix + 'guidlines.terms')"></p>
      </div>
    </div>
    <div v-if="catItem" class="tt-c-review-form-header__content--right">
      <tt-product-image v-if="catItem"
                        class="tt-c-review-form-header__product-image"
                        :catItem="catItem"
                        :includeAlt="false"
                        :siblingSiteKey="siblingSiteKey"></tt-product-image>
    </div>
    <div v-else-if="forSellerRating && siteLogo" class="tt-c-review-form-header__content--right">
      <img :src="siteLogo" class="tt-c-review-form-header__logo" :alt="globalConfig.siteName">
    </div>
  </div>
</div>
